<template>
  <v-card>
    <v-card-title>
      {{ $t("fund.report.stepModelRequirements.title") }}
    </v-card-title>

    <v-simple-table class="v-align-top table-no-hover">
      <template #default>
        <tbody>
          <template v-for="(category, index) in categories">
            <tr :key="index">
              <td colspan="2">
                <h3>
                  {{ $t(`stepModelRequirementCategory.${index}.name`) }}
                </h3>
              </td>
            </tr>

            <tr v-for="requirement in category" :key="requirement.id">
              <td width="50%">
                <strong>
                  {{ $t(`stepModelRequirement.${requirement.requirementId}.name`) }}
                </strong>

                <Markdown :value="$t(`stepModelRequirement.${requirement.requirementId}.help`)" />

                <Markdown :value="$t(`stepModelRequirement.${requirement.requirementId}.description`)" />
              </td>

              <td width="50%">
                <ResponseList :responses="requirement.protocol" />

                <Feedback :requirement="requirement" />
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import groupByCategory from "@/utils/Requirements/groupByCategory";
import ResponseList from "@/components/Fund/ResponseList";
import Feedback from "./Feedback.vue";

export default {
  components: {
    ResponseList,
    Feedback,
  },

  props: {
    requirements: {
      type: Array,
      required: true,
    },
  },

  computed: {
    categories() {
      return groupByCategory(this.requirements);
    },
  },
};
</script>
